<template>
  <div>
    <h1>{{ $t("chapter.chapterContents") }}</h1>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-2">{{
          $t("chapter.infoPopup.infoPopups")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="pa-2">
          <v-expansion-panels class="info-popup-panels">
            <v-expansion-panel v-for="(markInfo, index) in marks" :key="index">
              <v-expansion-panel-header class="pa-1" style="min-height: 0"
                >{{ readMoreString(markInfo.text) }} :
                {{ index + 1 }}</v-expansion-panel-header
              >
              <v-expansion-panel-content v-if="editor" class="text-left pa-2">
                <MediaObjectUploadAlt
                  :mediaSource="infoSrcs[index]"
                  :formats="formats"
                  :maxSizeBytes="maxSizeBytes"
                  :errorTooLargeMessage="'2 big'"
                  @error="setErrorMessage"
                  @loading="loading = $event"
                  @input="changeMarkSrc($event, markInfo, index)"
                />
                {{ $t("chapter.infoPopup.textBlock") }}<br />
                <v-textarea
                  solo
                  v-model="infoTexts[index]"
                  @change="changeMarkText($event, markInfo)"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import { readMoreString } from "@/helpers/truncateString";
import { IMAGE_FORMATS, VIDEO_FORMATS, AUDIO_FORMATS } from "@/const";
import MediaObjectUploadAlt from "@/components/MediaObjectUploadAlt";
import debounce from "@/helpers/debounce";
export default {
  props: {
    editor: Object,
  },
  components: {
    MediaObjectUploadAlt,
  },
  data() {
    return {
      marks: [],
      infoTexts: [],
      infoSrcs: [],
      loading: false,
    };
  },
  computed: {
    MAX_DISPLAY_CHARS() {
      return 20;
    },
    formats() {
      return IMAGE_FORMATS + "," + VIDEO_FORMATS + ", " + AUDIO_FORMATS;
    },
    maxSizeBytes() {
      return null
    }
  },
  mounted() {
    this.editor.state.doc.descendants((node, pos) => {
      if (node.marks.length > 0) {
        for (const mark of node.marks) {
          if (mark.type.name == "info") {
            this.marks.push({
              text: node.text,
              nodeSize: node.nodeSize,
              pos: pos,
              mark: mark,
            });
            this.infoTexts.push(mark.attrs.info);
            this.infoSrcs.push(mark.attrs.src)
          }
        }
      }
    });
  },
  methods: {
    readMoreString(value) {
      return readMoreString(value, this.MAX_DISPLAY_CHARS);
    },
    setErrorMessage(error){
      console.log(error)
    },
    changeMarkText: debounce(async function (tempText, markInfo) {
      const infoMark = this.editor.schema.marks["info"];
      let mark = infoMark.create({
        info: tempText,
        src: markInfo.mark.attrs.src,
      });
      let start = markInfo.pos;
      let end = markInfo.pos + markInfo.nodeSize;
      const transaction = this.editor.state.tr.addMark(start, end, mark);
      this.editor.view.dispatch(transaction);
    }, 500),
    changeMarkSrc(src, markInfo, index) {
      const infoMark = this.editor.schema.marks["info"];
      let mark = infoMark.create({ info: markInfo.mark.attrs.info, src: src });
      let start = markInfo.pos;
      let end = markInfo.pos + markInfo.nodeSize;
      try {
        const transaction = this.editor.state.tr.addMark(start, end, mark);
        this.editor.view.dispatch(transaction);
      }
      catch(e) {
        console.log(e)
      }
      this.$set(this.infoSrcs, index, src)
    },
  },
};
</script>
<style lang="scss" scoped>
button.v-expansion-panel-header {
  min-height: 0;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

::v-deep .info-popup-panels.v-expansion-panels .v-expansion-panel {
  background-color: #d3eff8;
}
</style>